module.exports = __webpack_public_path__ + "assets/img/ECharts.a2939c4c.png";